import { useTranslation } from "react-i18next";

// Marker interpolated in place of the email so the translated sentence can be
// split around it and the email rendered as a mailto link (keeps word order
// translatable without needing the <Trans> component).
const EMAIL_MARKER = "__email__";

const SupportContent = ({ email }: { email: string }) => {
  const { t } = useTranslation("common");
  const [before, after = ""] = t("api_error.support", {
    email: EMAIL_MARKER,
  }).split(EMAIL_MARKER);

  return (
    <div data-testid="support-content">
      {before}
      <a href={`mailto:${email}`} className="underline hover:text-blue-700">
        {email}
      </a>
      {after}
    </div>
  );
};

export default SupportContent;
